import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Flex } from './Flex';

const StyledBanner = styled.div`
  position: fixed;
  bottom: 0;
  margin-top: 25px;
  left: 0;
  right: 0;
  min-height: 64px;
  background-color: #e8e8e8;
  @media screen and (min-width: 960px) {
    padding-left: 210px;
  }
`;

const BannerText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  margin-right: 20px;
  line-height: 60px;
  font-weight: normal;
`;

const BannerButton = withStyles({
  root: {
    color: 'white',
    fontWeight: 'normal',
    backgroundColor: '#ffab00',
  },
})(Button);

export const Banner = ({ bannerText, buttonText, onButtonClick }) => {
  return (
    <StyledBanner data-testid="banner">
      <Flex flexDirection="row" alignItems="center" justifyContent="center">
        <BannerText>{bannerText}</BannerText>
        <BannerButton data-testid="banner-button" onClick={onButtonClick}>
          {buttonText}
        </BannerButton>
      </Flex>
    </StyledBanner>
  );
};
